//
// Imports
//

import { Prisma } from "@prisma/client";
import { z } from "zod";

//
// Schemas
//

type ForumBoard = Pick<Prisma.ForumBoardGetPayload<null>, keyof Prisma.ForumBoardFieldRefs>;

export const IdSchema: z.ZodType<ForumBoard["id"], z.ZodTypeDef, any> = z
	.coerce
	.number()
	.int()
	.positive();